<template>
  <div>

    <search-group title="结算功能区查询" @search="findData" @clear="clearValue" :btnOffset="10" :inline="true">
      <Row :gutter="16" class="mb16">
        <Col span="4">
          <Select placeholder="合作模式" v-model="searchData.projectCooperationModel" disabled>
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in modelList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input style="display: block;" placeholder="项目名称" v-model="searchData.projectName"/>
        </Col>
      </Row>
    </search-group>

    <!--<search-list></search-list>-->
    <div >
      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
    </div>

  </div>
</template>

<script>
  // import TableList from "components/TableList/index";
  // import SearchGroup from 'components/SearchGroup/index';
  import {getPropBalConfigList} from "../../api/projectSettlemet";
  import {formatDateTime} from "../../utils/format";


  // import SearchList from './components/SearchList'
  export default {
    name: "projectsettlement11",
    components: {
      // TableList,
      // SearchGroup
    },
    created() {
      this.findData()
    },
    data() {
      return {

        modelList: [{text: '直营', value: 0}, {text: '托管', value: 1}],
        searched: null,
        searchData: {
          projectName: '',
          projectCooperationModel: 1,

        },
        columns: [
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title: "项目",
            key: "projectName",
            align: "center",
          },
          {
            title: "合作模式",
            key: "projectCooperationModelName",
            align: "center",
          },
          {
            title: "账期类型",
            key: "balancePeriodTypeName",
            align: "center",
          },
          {
            title: "更新时间",
            key: "lastModifyTime",
            align: "center",
            render: (h, params) => {
              return h('span', {}, formatDateTime(params.row['lastModifyTime'], false))
            }
          },
          {
            title: "操作",
            key: "",
            align: "center",
            render: (h, params) => {
              return h('div', {}, [
                h('a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'proprietor/getPropBalConfigDetail'
                      }
                    }
                  ],
                  style: {
                    marginRight: '15px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'projectsettledetail', query: {id: params.row['fid'],pid:params.row['projectFid'],pname:params.row['projectName'], isRead: 1}})
                    }
                  }

                }, '查看'),
                h('a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'proprietor/savePropBalConfig'
                      }
                    }
                  ],
                  on: {
                    click: () => {
                      this.$router.push({name: 'projectsettledetail', query: {id: params.row['fid'],pid:params.row['projectFid'], pname:params.row['projectName'],isRead: 0}})
                    }
                  }

                }, '修改')
              ])
            }
          },

        ],
        data: [],
        loading: false,
        total: 0,
        current: 1,

      }
    },
    methods: {
      getPropBalConfigList(data) {
        let params = {
          page: this.page,
          limit: 10,
          ...data
        }
        getPropBalConfigList(params).then(res => {
          if (!res.data) {
            return
          }
          this.searched = data

          this.total = res.data.total
          res.data.rows && (this.data = res.data.rows)

        }).catch(error => {
        })
      },
      changePage(n) {
        this.page = n
        this.current = n
        this.getPropBalConfigList(this.searched)
      },
      findData() {
        this.page = 1
        this.current = 1
        this.getPropBalConfigList(this.searchData)
      },
      clearValue() {
        this.searchData = {
          projectName: '',
          projectCooperationModel: 1

        }

      }
    }

  }
</script>

<style scoped>

</style>
